import React from 'react';
import { Link } from 'react-router';

import { WarningDanger } from '../../components/icons';
import { useCurrentMember } from '../../hooks/use-current-member';

import styles from './past-due-subscription-banner.module.scss';
type PastDueSubscriptionBannerProps = {
  spaceId: string;
};

export const PastDueSubscriptionBanner: React.FC<PastDueSubscriptionBannerProps> = ({
  spaceId,
}) => {
  const currentMember = useCurrentMember();

  return (
    <div className={styles['banner']}>
      <WarningDanger />
      <span className={styles['text']}>
        Your payment is overdue.{' '}
        <span>Update your payment method to avoid loosing access to your space.</span>
      </span>

      {['owner', 'admin'].includes(currentMember?.role || '') && (
        <Link to={`/space/${spaceId}/settings/billings`}>Go to settings</Link>
      )}
    </div>
  );
};
